module.exports = __webpack_public_path__ + "static/assets/34ff575693d44477a31c817d38161737.gif";